const tests = []
export default tests

import Chai from "chai"
import Keyset from "@frog/source/utility/Keyset.js"

tests.push({
    "slug": "keyset/convert/1",
    "description": "Keyset.convert can convert an array into a set.",
    "func": function() {
        const alphalist = [
            {"key": "one", "number": 1},
            {"key": "two", "number": 2},
            {"key": "three", "number": 3},
        ]
        const omegaset = {
            "one": {"key": "one", "number": 1},
            "two": {"key": "two", "number": 2},
            "three": {"key": "three", "number": 3},
        }

        Chai.expect(Keyset.convert(alphalist)).to.deep.equal(omegaset)
    }
})

tests.push({
    "slug": "keyset/convert/2",
    "description": "Keyset.convert won't convert if it is already a set.",
    "func": function() {
        const set = {
            "one": {"key": "one", "number": 1},
            "two": {"key": "two", "number": 2},
            "three": {"key": "three", "number": 3},
        }

        Chai.expect(Keyset.convert(set)).to.deep.equal(set)
    }
})

tests.push({
    "slug": "keyset/merge",
    "description": "Keyset.merge can combine two sets.",
    "func": function() {
        const set1 = {
            "red": {"key": "red", "fruit": "apple"}, // apple will be replaced by strawberry
            "blue": {"key": "blue", "fruit": "blueberry"}, // blueberry will be deleted by undefined
            "green": {"key": "green", "fruit": "lime"},
        }
        const set2 = {
            "red": {"key": "red", "fruit": "strawberry"},
            "blue": undefined,
            "yellow": {"key": "yellow", "fruit": "banana"},
        }

        Chai.expect(Keyset.merge(set1, set2)).to.deep.equal({
            "red": {"key": "red", "fruit": "strawberry"},
            "green": {"key": "green", "fruit": "lime"},
            "yellow": {"key": "yellow", "fruit": "banana"},
        })
    }
})

tests.push({
    "slug": "keyset/find",
    "description": "Keyset.find can search a set with a conditional expression.",
    "func": function() {
        const set = {
            "twenty-five": {"key": "twenty-five", "number": 25}, // 25 will be found before 1 because it is earlier
            "one-hundred": {"key": "one-hundred", "number": 100},
            "one": {"key": "one", "number": 1},
        }
        const greaterThanFifty = (value) => value.number > 50
        const lessThanFifty = (value) => value.number <= 50

        Chai.expect(Keyset.find(set, greaterThanFifty)).to.deep.equal({"key": "one-hundred", "number": 100})
        Chai.expect(Keyset.find(set, lessThanFifty)).to.deep.equal({"key": "twenty-five", "number": 25})
    }
})

tests.push({
    "slug": "keyset/map",
    "description": "Keyset.map can iterate over a set.",
    "func": function() {
        const set = {
            "a": {"key": "a", "number": 10},
            "b": {"key": "b", "number": 100},
            "c": {"key": "b", "number": 1000},
        }
        const iterator = (value) => {
            return {
                "key": value.key,
                "number": value.number * 2
            }
        }

        Chai.expect(Keyset.map(set, iterator)).to.deep.equal({
            "a": {"key": "a", "number": 20},
            "b": {"key": "b", "number": 200},
            "c": {"key": "b", "number": 2000},
        })
    }
})


// Missing tests:
// "Keyset.convert can handle unkey'd values by assigning a unique key."
// "Keyset.xyz will handle an undefined set/list by handling it like an empty set/list."
// "Keyset.find/map will throw an error for an undefined iterator function."
// "Keyset.merge/map will return new sets, and will not mutate the old set."
// "Keyset.map will still save a value by its old key, even if the iterator function changed the value.key"
